import { useQuery } from '@tanstack/react-query';
import {
  type CallInCadenceReportResponse,
  type CallInCadenceWindowDays,
  DEFAULT_CALL_IN_CADENCE_WINDOW_DAYS,
} from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

export function useCallInCadenceReport(
  customerId: number | undefined,
  windowDays: CallInCadenceWindowDays = DEFAULT_CALL_IN_CADENCE_WINDOW_DAYS,
) {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['reports', 'call-in-cadence', customerId, windowDays],
    queryFn: () =>
      apiClient.get<CallInCadenceReportResponse>(
        `reports/call-in-cadence?customerId=${customerId}&windowDays=${windowDays}`,
      ),
    enabled: typeof customerId === 'number' && customerId > 0,
    // Don't retry — this is a heavy query with a server-side timeout. A retry
    // would double the user's wait on failure without changing the outcome.
    retry: false,
  });
}
